import { ConvertHTMLtoComponents } from "@polestar/component-warehouse-react";
import React from "react";

import { overrideElementMap } from "../ContentWithHtml/overrideElementMap";

const InlineDocumentBody = ({
  body,
  id,
}: {
  readonly __typename: string;
  readonly id: string;
  readonly body: string;
}) => {
  return (
    <ConvertHTMLtoComponents
      data-typename="LegalDocumentBody"
      id={id}
      overrideElementMap={overrideElementMap}
    >
      {body}
    </ConvertHTMLtoComponents>
  );
};

export default InlineDocumentBody;
